<template>
  <b-container>
    <b-breadcrumb>
      <b-breadcrumb-item to="/admin">Admin</b-breadcrumb-item>
      <b-breadcrumb-item active>Users</b-breadcrumb-item>
    </b-breadcrumb>
    <h1>All Users</h1>
    <users-table :count="25" pagination />
  </b-container>
</template>

<script>
import UsersTable from '@/components/admin/UsersTable'

export default {
  name: 'Users',
  components: {
    UsersTable
  }
}
</script>
